import React, { useCallback, useEffect, useRef } from 'react';

import i18n from '@nextroll/ar-i18n';
import { Option, SelectButton } from '@nextroll/ar-style-base';

import { useRoflStore } from 'store/roflStore';
import { WorkflowBaseType, WORKFLOW_BASE } from 'types/rofl';


interface IProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    onCreate?: ({ base }: { base?: WorkflowBaseType }) => void;
}

export const WorkflowTemplatesCreateButton = (props: IProps) => {
    const { open, setOpen, onCreate } = props;

    const [updateBase] = useRoflStore(state => [state.updateBase]);

    const containerRef = useRef(null);

    /**
     * click-away listener for closing the menu when clicking at else-where
     */
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (containerRef.current && !(containerRef.current as any).contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [containerRef, setOpen]);

    const handleCreate = useCallback((base: WorkflowBaseType) => {
        updateBase(base);
        onCreate?.({ base });
    }, [updateBase, onCreate]);

    return (
        <div className='workflows-templates-btn-create' ref={containerRef}>
            <SelectButton
                open={open}
                label={i18n.gettext('Create')}
                menuClassName='workflows-templates-btn-create-menu'
            >
                <Option showCheckbox={false} onClick={() => handleCreate(WORKFLOW_BASE.CONTACTS)}>
                    {i18n.gettext('Act on Existing CRM Contacts')}
                    <br />
                    <small>{i18n.gettext('Take action on existing Contacts like updating fields on a Contact or adding them to a Campaign')}</small>
                </Option>
                <Option showCheckbox={false} onClick={() => handleCreate(WORKFLOW_BASE.ACCOUNTS)}>
                    {i18n.gettext('Acquire New Contacts / Accounts')}
                    <br />
                    <small>{i18n.gettext('Discover Contacts and Accounts that are not in your CRM')}</small>
                </Option>
            </SelectButton>
        </div>
    );
};
